<template>
    <div class="other-client-list">
        <h4>Otros Clientes</h4>
        <div class="form-group">
            <app-autocomplete
                :items="clients"
                v-model="theClient"
                label="Seleccione el cliente"
            ></app-autocomplete>
            <!-- <label for="">Seleccione el cliente</label>
            <select name="other-clients" id="other-clients" class="form-control" v-model="theClient" @change="$v.theClient.$touch()">
                <option value="">-- Seleccione --</option>
                <option v-for="client in clients" :value="client">{{ client.name }}</option>
            </select>
            <span class="field-error" v-if="$v.theClient.$error">Debe selecionar un cliente de la lista</span> -->
        </div>
        <button class="btn btn-primary btn-block" @click="setClient">Ingresar con otro cliente</button>
        <app-pop-up
            id="select-access-point"
            title="Seleccione el puesto de vigilancia"
        >
            <div slot="body">
                <b-row v-for="ap in accessPoints" :key="ap.id">
                    <b-col cols="12">
                        <b-btn block variant="confirm" @click="setAccessPoint(ap)">{{ ap.name }}</b-btn>
                    </b-col>
                </b-row>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import shiftRepository from '../../../../repositories/shifts.repository';
    import * as actions from '../../../../store/actionTypes';
    import Autocomplete from '@components/UI/Controls/AutocompleteV2/Autocomplete';
    export default {
        components: {
            appAutocomplete: Autocomplete
        },
        data() {
            return {
                theClient: null
            }
        },
        validations: {
            theClient: {
                required
            }
        },
        computed: {
            ...mapGetters(['otherClients']),
            clients() {
                return this.otherClients.sort((a, b) => a.name - b.name);
            },
            accessPoints() {
                if(!this.theClient) return [];
                return this.theClient.structures.filter(item => !!item.structure_type.access_point && !item.venue.deleted_at);
            }
        },
        methods: {
            setClient() {
                if(!this.accessPoints.length) {
                    toastr.error('El cliente no tiene puestos de vigilancia configurados');
                    return false;
                }
                if(this.accessPoints.length === 1){
                    this.setAccessPoint(this.accessPoints[0]);
                } else {
                    this.$bus.$emit('select-access-point.open');
                }
            },
            setAccessPoint(ap) {
                if (this.theClient) {
                    

                    const isOther = true;
                    this.$store.commit('client', this.theClient);
                    this.$store.commit('accessPoint', ap);
                    this.$store.dispatch('entries', this.theClient.id);
                    this.$store.dispatch('loadPendingMail');
                    this.$store.dispatch(actions.LOAD_RESTRICTED_VISITORS, this.theClient.id);

                    // Validar si hay un turno iniciado para continuar con la vigilancia
                    const sr = Object.assign({}, shiftRepository);
                    sr.validateOpenShift(ap.id ,this.user.id)
                    .then(data=> {
                        this.$bus.$emit('select-access-point.close');
                        if(data.status){
                            toastr.success('Existe un turno que no se ha cerrado, continuará en este turno');
                            this.$store.commit('shift', data.shift);
                            this.$router.push({ name: this.user.profile.default_screen, params: { isOther } });

                        }else{
                            this.$router.push({ name: 'shiftStartPage'}); 
                        }
                    })
                    .catch(error=> {
                        toastr.error('Ocurrio un error al validar el turno');
                    });

                    // this.$router.push({
                    //     name: this.user.profile.default_screen, params: { isOther }
                    // });
                } else {
                    toastr.error("Seleccione un cliente");
                }
            }
        }
    }
</script>